import { TextInput } from "react-admin";
import {
  SABIL_AUDIT_REMARK_HELPER,
  SABIL_AUDIT_REMARK_LABEL,
} from "../requires-sabil-edit-audit-remark";

/** Always shown on sabil edit so reason is available for every save (including family-only). */
export function SabilAuditRemarkInput() {
  return (
    <TextInput
      source="auditRemark"
      label={SABIL_AUDIT_REMARK_LABEL}
      helperText={SABIL_AUDIT_REMARK_HELPER}
      fullWidth
      multiline
      minRows={2}
      isRequired
    />
  );
}
